import {callURL} from './call';
import messageShow from "./messageShow";
import language from "../languages/language";
import startOver from "./startOver";
import {signerURL} from "../url";
import logout from "./logout";

const putTemplates= (formValues) => async (dispatch, getState) =>
{
    delete formValues.templates;
    const ids=formValues.ids;
    const order=formValues.order;
    const manager=formValues.manager;
    const mail=formValues.mail;
    let files=[],fileNames=[],promises=[],errors=[];
    if(!ids || ids.length<1)
    {
        dispatch(messageShow({message: "Debe seleccionar por lo menos una plantilla", type: 'error'}));
        return;
    }
    if(!order)
    {
        dispatch(messageShow({message: "La orden es requerida", type: 'error'}));
        return;
    }
    if(!manager)
    {
        dispatch(messageShow({message: "El jefe de sala es requerido", type: 'error'}));
        return;
    }
    if(!mail)
    {
        dispatch(messageShow({message: "El correo del usuario es requerido", type: 'error'}));
        return;
    }
    formValues.returnBase64File=true;
    const numFiles=ids.length;
    for(let i=0;i<numFiles;i++)
    {
        //formValues.selectedTemplate=ids[i];
        formValues.id=ids[i];
        const onResult= (result) =>
        {
            if(result && result[1].success)
            {
                files.push(result[1].base64File);
                fileNames.push("combined.pdf");
            }
            else
            {
                errors.push(result);
                dispatch(messageShow({message: result[1].detail, type: 'error'}));
            }

        }
        promises.push(dispatch(callURL(signerURL,"rest/UserService/getPDFTemplate",formValues,onResult)));
    }
    Promise.all(promises).then(()=>
    {
        if(errors.length>0)
        {
            const result=errors[0];
            if(result && result[1] && result[1].code===440)
                dispatch(logout());
            return;
        }
        delete formValues.selectedTemplate;
        if(numFiles===1)
            putFiles(dispatch,formValues,getState,order,mail,manager,files[0]);
        else
        {
            formValues.base64Files=files;
            formValues.fileNames=fileNames;
            const onResultCombine= (resultCombine) =>
            {
                if(resultCombine && resultCombine[1].success)
                {
                    delete formValues.base64Files;
                    delete formValues.fileNames;
                    putFiles(dispatch,formValues,getState,order,mail,manager,resultCombine[1].base64File);
                }
                else
                    dispatch(messageShow({message: resultCombine[1].detail, type: 'error'}));
            }
            dispatch(callURL(signerURL,"rest/UserService/combinePDFs",formValues,onResultCombine));
        }
    });
};

const putFiles=(dispatch, formValues, getState,order, mail, manager, file)=>
{
    formValues.base64FileBytes=file;
    formValues.optMessage=formValues.comment;
    formValues.fileName=order + ".pdf";
    formValues.usersToPut=[mail,manager];
    formValues.sendConfirmation=true;
    formValues.sendAll=true;
    formValues.ordered=true;
    const onResultPut= (resultPut) =>
    {
        if(resultPut && resultPut[1].success)
        {
            dispatch(messageShow({message: language[getState().auth.language].advOKMessage, type: 'success'}));
            dispatch(startOver());
        }
        else
            dispatch(messageShow({message: resultPut[1].detail, type: 'error'}));
    }
    dispatch(callURL(signerURL,"rest/UserService/putFiles",formValues,onResultPut));
};

export default putTemplates;